import { Component } from "react";
import BetterCircularProgress from "../../components/BetterCircularProgress";
import Swal from "sweetalert2";
import * as equipe from "../../crud/equipe.crud";
import { formatBRL, formatDateTimeLocal } from "../../utils/Utils";
import { STATUS_VIAGEM_LABELS } from "../../utils/Constants";
import styles from "../../styles/Equipe.module.scss";
import Breadcrumb from "../../components/Breadcrumb";

const BTN_TABELA = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    padding: "8px",
    background: "var(--gray-3)",
    borderRadius: "2px",
    border: "none",
    cursor: "pointer",
    color: "var(--gray-9)",
    flexShrink: 0,
    boxSizing: "border-box",
};

export default class EquipeShow extends Component {
    state = {
        colaborador: null,
        loading: true,
    };

    componentDidMount() {
        const { id } = this.props.match.params;

        equipe.get(id)
            .then((res) => {
                this.setState({ colaborador: res.data, loading: false });
            })
            .catch(() => {
                Swal.fire("Ops!", "Não foi possível carregar os dados do membro.", "error");
                this.props.history.push("/equipe");
            });
    }

    renderStatusBadge = (status) => {
        const info = STATUS_VIAGEM_LABELS[status] || { label: status, classeKey: "badgeSolicitada" };

        return (
            <span className={`${styles.badge} ${styles[info.classeKey]}`}>
                {info.label}
            </span>
        );
    };

    formatarTarifa = (viagem) => {
        if (!viagem.tarifa_valor) return "—";

        const horas = Math.floor(viagem.tarifa_valor.tar_duracao / 60);
        const km = parseInt(viagem.tarifa_valor.tar_km_inclusa);

        return `${horas}h - ${km}km`;
    };

    render() {
        const { colaborador, loading } = this.state;

        if (loading) {
            return (
                <BetterCircularProgress loading={true} />
            );
        }

        const viagens = colaborador.viagens || [];

        return (
            <div className={styles.container}>
                <Breadcrumb paiTo="/equipe" paiLabel="Equipe" atual="Visualizar detalhes" />

                <div className={styles.card} style={{ overflow: "hidden" }}>
                    <div>
                        <p className={styles.secaoTitulo}>Dados gerais</p>

                        <div className={styles.dadosGrid}>
                            <div className={styles.dadoItem}>
                                <p className={styles.dadoLabel}>Nome</p>
                                <p className={styles.dadoValor}>{colaborador.usr_nome}</p>
                            </div>

                            <div className={styles.dadoItem}>
                                <p className={styles.dadoLabel}>E-mail</p>
                                <p className={styles.dadoValor}>{colaborador.email}</p>
                            </div>
                        </div>
                    </div>

                    <span className={styles.divisor} />

                    <div>
                        <p className={styles.secaoTitulo}>Permissões</p>

                        <div className={styles.dadosGrid}>
                            <div className={styles.dadoItem}>
                                <p className={styles.dadoLabel}>Permitir solicitação de viagens em nome da empresa</p>
                                <p className={styles.dadoValor}>{colaborador.usr_pode_solicitar_viagens ? "Sim" : "Não"}</p>
                            </div>

                            <div className={styles.dadoItem}>
                                <p className={styles.dadoLabel}>Acessar painel da empresa</p>
                                <p className={styles.dadoValor}>{colaborador.usr_possui_acesso_painel ? "Sim" : "Não"}</p>
                            </div>
                        </div>
                    </div>

                    <span className={styles.divisor} />

                    <div className={styles.secaoHistorico}>
                        <p className={styles.secaoTitulo}>Histórico de viagens</p>

                        <div className={styles.tabelaViagensWrapper}>
                            {viagens.length === 0 ? (
                                <p className={styles.viagensVazio}>
                                    Nenhuma viagem encontrada.
                                </p>
                            ) : (
                                <table className={styles.tabelaViagens}>
                                    <thead>
                                        <tr>
                                            <th>Data da viagem</th>
                                            <th>Tarifa de locação</th>
                                            <th>Valor</th>
                                            <th>Status</th>
                                            <th>Ações</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {viagens.map((viagem) => (
                                            <tr key={viagem.id}>
                                                <td>{formatDateTimeLocal(viagem.via_data_solicitacao)}</td>
                                                <td>{this.formatarTarifa(viagem)}</td>
                                                <td>{formatBRL(viagem.via_valor_total)}</td>
                                                <td>{this.renderStatusBadge(viagem.via_status)}</td>
                                                <td>
                                                    <div className={styles.acoesColuna}>
                                                        <button
                                                            style={BTN_TABELA}
                                                            title="Ver viagem"
                                                            onClick={() => this.props.history.push(`/viagens/${viagem.id}`)}
                                                        >
                                                            <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>visibility</span>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
